import { Stack, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { ATSConnectHiringRequestRequestReferenceTestIds } from 'data-testids/ATS';
import { PrimaryButton, SecondaryButton } from 'sharedComponents/Buttons';
import {
  primaryButtonOverrideSx,
  secondaryButtonOverrideSx,
} from 'sharedComponents/Buttons/styles';
import { ReferenceCreateCTAButtonsProps } from 'features/References';
import { removeJSXFromText } from 'utils/text';
import { Right } from 'features/Connect/features/ConnectATSIntegration/styles/scorecardStyles';

export const ReferenceCreateCTAButtons: React.FC<ReferenceCreateCTAButtonsProps> = ({
  isLoading,
  onBackClick,
  onSaveAsDraft,
  isCreatingNewReferenceCheck = true,
}) => {
  const theme = useTheme();
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const message = watch('message');
  const emailMessageContentIsEmpty = message && removeJSXFromText(message).length === 0;

  const submitShouldBeDisabled =
    Object.keys(errors).length > 0 || isLoading || emailMessageContentIsEmpty;

  return (
    <Stack direction="row" sx={{ mt: 2, justifyContent: 'space-between' }}>
      <SecondaryButton
        dataTestId={ATSConnectHiringRequestRequestReferenceTestIds.CANCEL_BUTTON}
        onClick={() => onBackClick(false)}
        sx={{
          ...secondaryButtonOverrideSx(theme),
          width: isCreatingNewReferenceCheck ? '33%' : '50%',
        }}
      >
        Cancel
      </SecondaryButton>
      <Right sx={{ width: '50%' }}>
        {isCreatingNewReferenceCheck && (
          <SecondaryButton
            onClick={() => {
              setValue('is_complete', false);
              onSaveAsDraft();
            }}
            sx={{
              ...secondaryButtonOverrideSx(theme),
              width: '50%',
              marginRight: theme.spacing(1),
            }}
          >
            Save as Draft
          </SecondaryButton>
        )}
        <PrimaryButton
          dataTestId={ATSConnectHiringRequestRequestReferenceTestIds.SUBMIT_BUTTON}
          disabled={Boolean(submitShouldBeDisabled)}
          onClick={() => setValue('is_complete', true)}
          sx={{
            ...primaryButtonOverrideSx(theme),
            width: isCreatingNewReferenceCheck ? '50%' : '100%',
            marginLeft: theme.spacing(1),
          }}
          type="submit"
        >
          Submit
        </PrimaryButton>
      </Right>
    </Stack>
  );
};
